import {
  CardId,
  TCardLayoutSlot,
  TCard,
} from '@/console/features/card-layout/card-layout.types';

export const isValidDropZone = (
  cardId: CardId,
  slot: TCardLayoutSlot,
  allCards: TCard[],
): boolean => {
  if (cardId === CardId.PIPELINES) {
    return slot === TCardLayoutSlot.TOP || slot === TCardLayoutSlot.BOTTOM;
  }

  const pipeline = allCards.find((card) => card.id === CardId.PIPELINES);

  if (
    pipeline &&
    allCards.find((card) => card.id === cardId)?.position.slot ===
      TCardLayoutSlot.RIGHT &&
    (slot === TCardLayoutSlot.TOP || slot === TCardLayoutSlot.BOTTOM) &&
    pipeline.position.slot === slot
  ) {
    return false;
  }

  return true;
};
